import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import printerApiController from "services/printer.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
export const usersAdapter = createEntityAdapter();

const printerErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const calendarPrintRejectedValue = (error) => ({
  status: error?.response?.status,
  message: error?.response?.data || error?.message || "Unable to print the calendar. Please try again.",
});

export const CalendarAppointmentPrintApi = createAsyncThunk("printer/calendar-appointment-print", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await printerApiController
      .calendarappointmentprints(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "calendar-appointment-print"))
      .catch((error) => HandleError(thunkAPI, error, "calendar-appointment-print"));
    return resposedata;
  } catch (error) {
    return thunkAPI.rejectWithValue(calendarPrintRejectedValue(error));
  }
});
export const settingPlanhistoryApi = createAsyncThunk("printer/planhistory", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await printerApiController
      .settingPlanhistory(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "settingplanhistory"))
      .catch((error) => HandleError(thunkAPI, error, "settingplanhistory"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const clientAppointmentTabInvoiceApi = createAsyncThunk("printer/appointmenthistory", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await printerApiController
      .clientAppointmentTabInvoice(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "clientappointmenthistory"))
      .catch((error) => HandleError(thunkAPI, error, "clientappointmenthistory"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const clientDetailPrinterApi = createAsyncThunk("printer/details", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await printerApiController
      .clientdetail(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "clientdetails"))
      .catch((error) => HandleError(thunkAPI, error, "clientdetails"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const clientDetailAppointmentPrintApi = createAsyncThunk("printer/appointment", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await printerApiController
      .clientDetailAppointmentPrint(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "clientappointment"))
      .catch((error) => HandleError(thunkAPI, error, "clientappointment"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const clientDetailInvoicePrintApi = createAsyncThunk("printer/invoices", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await printerApiController
      .clientinvoicesprint(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "clientinvoices"))
      .catch((error) => HandleError(thunkAPI, error, "clientinvoices"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const saleVoucherPrintApi = createAsyncThunk("printer/vouchersale", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await printerApiController
      .saleVoucherPrint(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "vouchersale"))
      .catch((error) => HandleError(thunkAPI, error, "vouchersale"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const calendarPrintApi = createAsyncThunk("printer/printercalendar", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await printerApiController
      .calendarPrinter(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "printercalendar"))
      .catch((error) => HandleError(thunkAPI, error, "printercalendar"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const reportPrintApi = createAsyncThunk("printer/printerreport", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await printerApiController
      .reportPrinter(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "printerreport"))
      .catch((error) => HandleError(thunkAPI, error, "printerreport"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const subscriptionTermsConditionPrintApi = createAsyncThunk("printer/subscriptions/termsconditions", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await printerApiController
      .subscriptionTandC(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "termsconditions"))
      .catch((error) => HandleError(thunkAPI, error, "termsconditions"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});


const initialState = {
  issettingPlanhistoryApi: "",
  issettingPlanhistoryError: "",
  isclientAppointmentTabInvoice: "",
  isclientAppointmentTabInvoiceError: "",
  isclientDetailprinterApi: "",
  isclientDetailPrinterError: "",
  issaleVoucherPrint: "",
  issaleVoucherPrintError: "",
  issettingPlanhistoryApi: "",
  iscalendarPrinter: "",
  iscalendarPrinterError: "",
  isreportPrinter: "",
  isreportPrinterError: "",
  isclientDetailAppointmentPrint: [],
  isclientDetailAppointmentPrintError: "",
  isclientDetailInvoicePrint: "",
  isclientDetailInvoicePrintError: "",
  isCalendarAppointmentPrint: [],
  isCalendarAppointmentPrintError: "",
  isSubscriptionTermsConditionPrintData: "",
  isSubscriptionTermsConditionPrintError: "",
  isApiStatus: {
    settingPlanhistoryApi: "",
    clientAppointmentTabInvoiceApi: "",
    clientDetailPrinterApi: "",
    clientDetailAppointmentPrintApi: "",
    saleVoucherPrintApi: "",
    calendarPrintApi: "",
    reportPrintApi: "",
    CalendarAppointmentPrintApi: "",
    subscriptionTermsConditionPrintApi: ""
  },
};

const printerSlice = createSlice({
  name: "printer",
  initialState,
  reducers: {
    reset: () => initialState,

  },
  extraReducers: (builder) => {
    builder
      .addCase(subscriptionTermsConditionPrintApi.pending, (state) => {
        state.isSubscriptionTermsConditionPrintError = "";
        state.isApiStatus.subscriptionTermsConditionPrintApi = "loading";
      })
      .addCase(subscriptionTermsConditionPrintApi.fulfilled, (state, action) => {
        state.isSubscriptionTermsConditionPrintData = action.payload;
        state.isSubscriptionTermsConditionPrintError = "";
        state.isApiStatus.subscriptionTermsConditionPrintApi = "succeeded";
      })
      .addCase(subscriptionTermsConditionPrintApi.rejected, (state, action) => {
        state.isApiStatus.subscriptionTermsConditionPrintApi = "failed";
        state.isSubscriptionTermsConditionPrintError = printerErrorMessage(action, "Unable to print subscription terms and conditions.");
      })
      .addCase(CalendarAppointmentPrintApi.pending, (state) => {
        state.isCalendarAppointmentPrintError = "";
        state.isApiStatus.CalendarAppointmentPrintApi = "loading";
      })
      .addCase(CalendarAppointmentPrintApi.fulfilled, (state, action) => {
        state.isCalendarAppointmentPrint = action.payload;
        state.isCalendarAppointmentPrintError = "";
        state.isApiStatus.CalendarAppointmentPrintApi = "succeeded";
      })
      .addCase(CalendarAppointmentPrintApi.rejected, (state, action) => {
        state.isApiStatus.CalendarAppointmentPrintApi = "failed";
        state.isCalendarAppointmentPrintError = printerErrorMessage(action, "Unable to print the calendar appointment.");
      })
      .addCase(settingPlanhistoryApi.pending, (state) => {
        state.issettingPlanhistoryError = "";
        state.isApiStatus.settingPlanhistoryApi = "loading";
      })
      .addCase(settingPlanhistoryApi.fulfilled, (state, action) => {
        state.issettingPlanhistoryApi = action.payload;
        state.issettingPlanhistoryError = "";
        state.isApiStatus.settingPlanhistoryApi = "succeeded";
      })
      .addCase(settingPlanhistoryApi.rejected, (state, action) => {
        state.isApiStatus.settingPlanhistoryApi = "failed";
        state.issettingPlanhistoryError = printerErrorMessage(action, "Unable to load plan history.");
      })
      .addCase(clientAppointmentTabInvoiceApi.pending, (state) => {
        state.isclientAppointmentTabInvoiceError = "";
        state.isApiStatus.clientAppointmentTabInvoiceApi = "loading";
      })
      .addCase(clientAppointmentTabInvoiceApi.fulfilled, (state, action) => {
        state.isclientAppointmentTabInvoice = action.payload;
        state.isclientAppointmentTabInvoiceError = "";
        state.isApiStatus.clientAppointmentTabInvoiceApi = "succeeded";
      })
      .addCase(clientAppointmentTabInvoiceApi.rejected, (state, action) => {
        state.isApiStatus.clientAppointmentTabInvoiceApi = "failed";
        state.isclientAppointmentTabInvoiceError = printerErrorMessage(action, "Unable to load the client appointment invoice.");
      })
      .addCase(clientDetailPrinterApi.pending, (state) => {
        state.isclientDetailPrinterError = "";
        state.isApiStatus.clientDetailPrinterApi = "loading";
      })
      .addCase(clientDetailPrinterApi.fulfilled, (state, action) => {
        state.isclientDetailprinterApi = action.payload;
        state.isclientDetailPrinterError = "";
        state.isApiStatus.clientDetailPrinterApi = "succeeded";
      })
      .addCase(clientDetailPrinterApi.rejected, (state, action) => {
        state.isApiStatus.clientDetailPrinterApi = "failed";
        state.isclientDetailPrinterError = printerErrorMessage(action, "Unable to load client print details.");
      })
      .addCase(saleVoucherPrintApi.pending, (state) => {
        state.issaleVoucherPrintError = "";
        state.isApiStatus.saleVoucherPrintApi = "loading";
      })
      .addCase(saleVoucherPrintApi.fulfilled, (state, action) => {
        state.issaleVoucherPrint = action.payload;
        state.issaleVoucherPrintError = "";
        state.isApiStatus.saleVoucherPrintApi = "succeeded";
      })
      .addCase(saleVoucherPrintApi.rejected, (state, action) => {
        state.isApiStatus.saleVoucherPrintApi = "failed";
        state.issaleVoucherPrintError = printerErrorMessage(action, "Unable to print the voucher sale.");
      })
      .addCase(calendarPrintApi.pending, (state) => {
        state.iscalendarPrinterError = "";
        state.isApiStatus.calendarPrintApi = "loading";
      })
      .addCase(calendarPrintApi.fulfilled, (state, action) => {
        state.iscalendarPrinter = action.payload;
        state.iscalendarPrinterError = "";
        state.isApiStatus.calendarPrintApi = "succeeded";
      })
      .addCase(calendarPrintApi.rejected, (state, action) => {
        state.isApiStatus.calendarPrintApi = "failed";
        state.iscalendarPrinterError = printerErrorMessage(action, "Unable to print the calendar.");
      })
      .addCase(reportPrintApi.pending, (state) => {
        state.isreportPrinterError = "";
        state.isApiStatus.reportPrintApi = "loading";
      })
      .addCase(reportPrintApi.fulfilled, (state, action) => {
        state.isreportPrinter = action.payload;
        state.isreportPrinterError = "";
        state.isApiStatus.reportPrintApi = "succeeded";
      })
      .addCase(reportPrintApi.rejected, (state, action) => {
        state.isApiStatus.reportPrintApi = "failed";
        state.isreportPrinterError = printerErrorMessage(action, "Unable to print the report.");
      })
      .addCase(clientDetailAppointmentPrintApi.pending, (state) => {
        state.isclientDetailAppointmentPrintError = "";
        state.isApiStatus.clientDetailAppointmentPrintApi = "loading";
      })
      .addCase(clientDetailAppointmentPrintApi.fulfilled, (state, action) => {
        state.isclientDetailAppointmentPrint = action.payload;
        state.isclientDetailAppointmentPrintError = "";
        state.isApiStatus.clientDetailAppointmentPrintApi = "succeeded";
      })
      .addCase(clientDetailAppointmentPrintApi.rejected, (state, action) => {
        state.isApiStatus.clientDetailAppointmentPrintApi = "failed";
        state.isclientDetailAppointmentPrintError = printerErrorMessage(action, "Unable to print the client appointment.");
      })
      .addCase(clientDetailInvoicePrintApi.pending, (state) => {
        state.isclientDetailInvoicePrintError = "";
        state.isApiStatus.clientDetailInvoicePrintApi = "loading";
      })
      .addCase(clientDetailInvoicePrintApi.fulfilled, (state, action) => {
        state.isclientDetailInvoicePrint = action.payload;
        state.isclientDetailInvoicePrintError = "";
        state.isApiStatus.clientDetailInvoicePrintApi = "succeeded";
      })
      .addCase(clientDetailInvoicePrintApi.rejected, (state, action) => {
        state.isApiStatus.clientDetailInvoicePrintApi = "failed";
        state.isclientDetailInvoicePrintError = printerErrorMessage(action, "Unable to print the client invoice.");
      });
  },
});
// Action creators are generated for each case reducer function
export const { reset } = printerSlice.actions;
export default printerSlice.reducer;
